<div class="hd-moments-calendar" [class.hd-moments-calendar--compact]="compact()">
  <div class="hd-moments-calendar__toolbar">
    <button type="button" class="hd-moments-calendar__nav" (click)="navigate(-1)"
            [attr.aria-label]="text().previous" data-test-id="calendar-previous">
      <i class="fas fa-chevron-left" aria-hidden="true"></i>
    </button>
    <button type="button" class="hd-moments-calendar__nav hd-moments-calendar__nav--today"
            (click)="goToToday()" [title]="text().today" data-test-id="calendar-today">
      {{ text().today }}
    </button>
    <button type="button" class="hd-moments-calendar__nav" (click)="navigate(1)"
            [attr.aria-label]="text().next" data-test-id="calendar-next">
      <i class="fas fa-chevron-right" aria-hidden="true"></i>
    </button>
    <!-- Klikbare maand + jaar: snel kiezen via het bekende drilldown-patroon. -->
    <span class="hd-moments-calendar__month" data-test-id="calendar-month-label">
      <button type="button" class="hd-moments-calendar__label-btn"
              [class.is-active]="pickerMode() === 'months'"
              [title]="text().pickMonth" [attr.aria-label]="text().pickMonth"
              (click)="toggleMonthPicker()" data-test-id="calendar-month-button">{{ monthName() }}</button>
      <button type="button" class="hd-moments-calendar__label-btn"
              [class.is-active]="pickerMode() === 'years'"
              [title]="text().pickYear" [attr.aria-label]="text().pickYear"
              (click)="toggleYearPicker()" data-test-id="calendar-year-button">{{ yearLabel() }}</button>
    </span>

    <span class="hd-moments-calendar__spacer"></span>

    @if (!isTransits()) {
      @for (category of categories; track category) {
        <label class="hd-moments-calendar__filter">
          <input type="checkbox" [checked]="!hiddenCategories().has(category)"
                 (change)="toggleCategoryFilter(category)"
                 [attr.data-test-id]="'calendar-category-' + category" />
          {{ text().category[category] }}
        </label>
      }
    }
    <!-- Extra toolbar-inhoud van de host (transits: poort/lijn-schakelaar). -->
    <ng-content select="[hdCalendarToolbarEnd]"></ng-content>
  </div>

  @if (pickerMode() === 'months') {
    <!-- Maandkiezer: twaalf maanden van het getoonde jaar. -->
    <div class="hd-moments-calendar__picker-grid" data-test-id="calendar-month-grid">
      @for (option of monthOptions(); track option.index) {
        <button type="button" class="hd-moments-calendar__picker-cell"
                [class.is-selected]="option.isSelected"
                [class.is-today]="option.isCurrent"
                (click)="pickMonth(option.index)"
                [attr.data-test-id]="'calendar-pick-month-' + option.index">
          {{ option.label }}
        </button>
      }
    </div>
  } @else if (pickerMode() === 'years') {
    <!-- Jaarkiezer: blok van twaalf jaren; ‹ › bladert per blok. -->
    <div class="hd-moments-calendar__picker-grid" data-test-id="calendar-year-grid">
      @for (option of yearOptions(); track option.year) {
        <button type="button" class="hd-moments-calendar__picker-cell"
                [class.is-selected]="option.isSelected"
                [class.is-today]="option.isCurrent"
                (click)="pickYear(option.year)"
                [attr.data-test-id]="'calendar-pick-year-' + option.year">
          {{ option.year }}
        </button>
      }
    </div>
  } @else {
    <div class="hd-moments-calendar__weekdays">
      @for (label of weekdayLabels(); track $index) {
        <span class="hd-moments-calendar__weekday">{{ label }}</span>
      }
    </div>

    <div class="hd-moments-calendar__grid">
      @for (week of weeks(); track $index) {
        @for (day of week; track day.key) {
          <button
            type="button"
            class="hd-moments-calendar__day"
            [class.is-outside]="!day.inMonth"
            [class.is-today]="day.isToday"
            [class.is-selected]="selectedDayKey() === day.key"
            [class.is-focus]="day.isFocus"
            [class.in-range]="day.inRange"
            (click)="selectDay(day)"
            [attr.data-test-id]="'calendar-day-' + day.key"
          >
            <!-- Kopregel: dagnummer links, host-inhoud rechts (transits: lijn-dag van de zon). -->
            <span class="hd-moments-calendar__day-head">
              <span class="hd-moments-calendar__day-number">{{ day.dayNumber }}</span>
              @if (dayCorner(); as corner) {
                <span class="hd-moments-calendar__corner">
                  <ng-container *ngTemplateOutlet="corner; context: { $implicit: day.key }" />
                </span>
              }
            </span>
            @if (isTransits()) {
              <!-- Planeten die die dag van poort (of lijn) wisselen. -->
              <span class="hd-moments-calendar__badges">
                @for (badge of day.badges; track badge.id) {
                  <span class="hd-moments-calendar__badge"
                        [class.hd-moments-calendar__badge--strong]="badge.strong"
                        [style.color]="badge.color"
                        [attr.title]="badge.tooltip">{{ badge.glyph }}</span>
                }
                @if (day.badgeOverflow > 0) {
                  <span class="hd-moments-calendar__more">+{{ day.badgeOverflow }}</span>
                }
              </span>
            } @else {
              <span class="hd-moments-calendar__dots">
                @for (marker of dotsFor(day); track marker.id) {
                  <span class="hd-moments-calendar__dot" [style.background]="dotColor(marker)"></span>
                }
                @if (overflowCount(day) > 0) {
                  <span class="hd-moments-calendar__more">+{{ overflowCount(day) }}</span>
                }
              </span>
            }
          </button>
        }
      }
    </div>
  }

  @if (!isTransits() && pickerMode() === 'days' && selectedDay(); as day) {
    <div class="hd-moments-calendar__day-panel" data-test-id="calendar-day-panel">
      @if (day.starts.length === 0) {
        <div class="hd-moments-calendar__empty">{{ text().empty }}</div>
      }
      @for (marker of day.starts; track marker.id) {
        <div class="hd-moments-calendar__entry">
          <span class="hd-moments-calendar__dot" [style.background]="dotColor(marker)"></span>
          <i class="fas fa-{{ marker.icon }} hd-moments-calendar__entry-icon" aria-hidden="true"></i>
          <span class="hd-moments-calendar__entry-label">{{ marker.label }}</span>
          <span class="hd-moments-calendar__entry-time">{{ markerTimeText(marker) }}</span>
          @if (marker.openChartId) {
            <button type="button" class="hd-moments-calendar__entry-open"
                    [title]="text().edit"
                    (click)="editMarker(marker)" data-test-id="calendar-entry-edit">
              <i class="fas fa-pen" aria-hidden="true"></i>
            </button>
          }
          <!-- Openen: een chart (mét Notities), of (I Tjing-moment) de raadpleging in de dialoog. -->
          @if (marker.openChartId || marker.consultationId) {
            <button type="button" class="hd-moments-calendar__entry-open"
                    (click)="openMarker(marker)" data-test-id="calendar-entry-open">
              {{ text().open }}
            </button>
          }
        </div>
      }
      <button type="button" class="hd-moments-calendar__add" (click)="addOnSelectedDay()"
              data-test-id="calendar-add">
        <i class="fas fa-plus" aria-hidden="true"></i> {{ text().addMoment }}
      </button>
    </div>
  }
</div>
